function getFlairCategoryText(filterName, value) {

    if (filterName === 'meetingLocation') {
        if (value == constants.meeting_location.INCALL) {
            return this.translate.home.inCall;
        } else if (value == constants.meeting_location.OUTCALL) {
            return this.translate.home.outCall;
        }
    }

    if (filterName === 'type') {
        if (value == constants.user_type.PROFESSIONAL) {
            return this.translate.home.professional;
        } else if (value == constants.user_type.AMATEUR) {
            return this.translate.home.amateur;
        }
    }

    if (filterName === 'isIndependentEscortCategory') {
        if (value === true) {
            return this.translate.account.independent;
        } else if (value === false) {
            return this.translate.account.agency;
        }
    }

    return '';
}

function getFlairCategoryTextMobile(category) {
    const result = [];

    if (!_.isNil(category.isIndependentEscortCategory)) {
        result.push(this.getFlairCategoryText('isIndependentEscortCategory', category.isIndependentEscortCategory));
    } else if (_.isNil(category.type)) {
        result.push(this.getFlairCategoryText('type', constants.user_type.AMATEUR));
        result.push(this.getFlairCategoryText('type', constants.user_type.PROFESSIONAL));
    } else {
        result.push(this.getFlairCategoryText('type', category.type));
    }

    if (_.isNil(category.meetingLocation)) {
        result.push(this.getFlairCategoryText('meetingLocation', constants.meeting_location.INCALL));
        result.push(this.getFlairCategoryText('meetingLocation', constants.meeting_location.OUTCALL));
    } else {
        result.push(this.getFlairCategoryText('meetingLocation', category.meetingLocation));
    }

    return result.join(', ');
}

function getFlairCategoryTextMobileWithoutDefaults(category) {

    if (!category) {
        return '';
    }

    const result = [];

    if (!_.isNil(category.isIndependentEscortCategory)) {
        result.push(this.getFlairCategoryText('isIndependentEscortCategory', category.isIndependentEscortCategory));
    } else if (!_.isNil(category.type)) {
        result.push(this.getFlairCategoryText('type', category.type));
    }

    if (!_.isNil(category.meetingLocation)) {
        result.push(this.getFlairCategoryText('meetingLocation', category.meetingLocation));
    }

    return result.join(', ');
}

function removeCategoryFlair(category, subFilter, value) {

    if (subFilter === 'isIndependentEscortCategory') {
        if (_.isNil(category.isIndependentEscortCategory)) {
            category.isIndependentEscortCategory = value === true ? false : true;
        } else {
            delete category.isIndependentEscortCategory;
        }
    }

    if (subFilter === 'type') {
        if (_.isNil(category.type)) {
            category.type = value == constants.user_type.AMATEUR
                ? constants.user_type.PROFESSIONAL
                : constants.user_type.AMATEUR
        } else {
            delete category.type;
        }
    }

    if (subFilter === 'meetingLocation') {
        if (_.isNil(category.meetingLocation)) {
            category.meetingLocation = value == constants.meeting_location.INCALL
                ? constants.meeting_location.OUTCALL
                : constants.meeting_location.INCALL
        } else {
            delete category.meetingLocation;
        }
    }

    return category;
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        getFlairCategoryText,
        removeCategoryFlair,
        getFlairCategoryTextMobile,
        getFlairCategoryTextMobileWithoutDefaults,
    },
    computed: {
        ...mapState([
            'translate'
        ]),
    },
}
